import _formatTags from "../../dict/formatTags.js";
const formatTags = _formatTags;
export default (function replaceBoldTags(text, openTag, closeTag) {
  let openPattern = new RegExp(formatTags.bold.open, "gmi"),
    closePattern = new RegExp(formatTags.bold.close, "gmi");
  return text.replace(openPattern, openTag).replace(closePattern, closeTag);
});